import { ca } from '@cian/analytics';
import { TAnalyticsSiteType } from '../../types/analytics';

export interface ITrackOpenAiModalProps {
  JkIds: number[];
  siteType: TAnalyticsSiteType;
}

interface ITrackAiSummaryActionProps {
  JkId: number;
  siteType: TAnalyticsSiteType;
}

type TAiSummaryAction = 'open' | 'change_tab' | 'report_error' | 'to_cardjk';

function trackAiSummaryEvent({ JkIds, action, siteType }: ITrackOpenAiModalProps & { action: TAiSummaryAction }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action,
    label: 'ai_summary',
    page: {
      siteType,
      pageType: 'CompareJKAiSummary',
      extra: {
        source: 'ListingCompareJK',
      },
    },
    products: JkIds.map(id => ({ id, offerType: 'JK' })),
  });
}

export function trackOpenAiModal({ JkIds, siteType }: ITrackOpenAiModalProps) {
  trackAiSummaryEvent({ JkIds, action: 'open', siteType });
}

export function trackSwitchAiSummaryTab({ JkId, siteType }: ITrackAiSummaryActionProps) {
  trackAiSummaryEvent({ JkIds: [JkId], action: 'change_tab', siteType });
}

export function trackReportErrorAiSummary({ JkId, siteType }: ITrackAiSummaryActionProps) {
  trackAiSummaryEvent({ JkIds: [JkId], action: 'report_error', siteType });
}

export function trackCardClickAiSummary({ JkId, siteType }: ITrackAiSummaryActionProps) {
  trackAiSummaryEvent({ JkIds: [JkId], action: 'to_cardjk', siteType });
}
